import { useState, useEffect } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios'; 
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import { useNavigate } from "react-router-dom";
import ComplaintUploadWithImagePreviewList from "./child/ComplaintUploadWithImagePreviewList";
import { getMediaUrl } from "../utils/uploadService";

const ComplainFormPageDispatchUpdate = ({ complainId }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const [dispatchEvidenceUrls, setDispatchEvidenceUrls] = useState([]);
  const [closureEvidenceUrls, setClosureEvidenceUrls] = useState([]);
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const authUserId = storedUser._id;
  const navigate = useNavigate();
  const [showAllSuggestions, setShowAllSuggestions] = useState(false);
  const [otherUsers, setOtherUsers] = useState([]);
  const [selectedOtherUserId, setSelectedOtherUserId] = useState('');
  const [isLoadingOtherUsers, setIsLoadingOtherUsers] = useState(false);

  const [formDataForest, setFormDataForest] = useState({ 
    forestZone: '',
    forestCircle: '',
    forestDivision: '',
    forestName: '', // ← NEW FIELD
    complaintAction: 'Proceed',
    closeRemarks: '',
    assignedOfficer: ''
  });

  // Checklist state for Administrative Department
  const [adminChecklist, setAdminChecklist] = useState({
    SO_Forest: false,
    AS_Admin: false,
    AS_Technical: false,
    AS_PM_E: false,
    DG_Forest: false,
    GIS_Lab_Manager: false,
    DS_Wildlife: false
  });

  const [selectedSuggestions, setSelectedSuggestions] = useState([]);

  const suggestions = [
    "Complaint Lacks Specific Location or Details.",
    "Person Details Not Found.",
    "Description/Content Irrelevant.",
    "No Evidence Provided.",
    "Issue Already Addressed by Department.",
    "Duplicate Complaint of an Existing Case.",
    "Complaint Outside Jurisdiction / Department Scope.",
    "Insufficient Details to Proceed.",
    "False or Misleading Information Reported.",
    "Complaint Withdrawn by Complainant.",
    "Natural climate.",
    "Not Related to Forestry / Wildlife Department.",
    "Action Already Taken Before Complaint Received."
  ];
  
  const [options, setOptions] = useState({
    forestZones: [],
    forestCircles: [],
    forestDivisions: [],
    forestNames: [], // ← NEW STATE FOR FOREST NAMES
  });

  const [formData, setFormData] = useState({
    dept_id: "",
    dept_name: "",
    district_id: "",
    complaint_district_name: "",
    complaint_number: "",
    complaint_nature_id: "",
    complaint_nature_name: "",
    complaint_nearby_place: "",
    complaint_detail: "",
    complainant_name: "",
    complainant_address: "",
    complainant_contact_no: "",
    complainant_email: "",
    complaint_time: "",
    complaint_additional_remarks: "",
    complainant_phone_secondry: "",
    other_nature: "",
    received_by: "",
    status: "Open",
    priority_level: "",
    cnic: "",
    complaint_source: "",
    complainant_city: "",
    complainant_tehsil: "",
    complainant_district: "",
    complaint_city: "",
    complaint_tehsil: "",
    complaint_district: "",
    complaint_address: "",
    media_array: [],
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setShowAttachmentsModal] = useState(false);

  // Checklist items
  const checklistItems = [
    { id: 'SO_Forest', label: 'SO Forest', icon: 'mdi:account-tie' },
    { id: 'AS_Admin', label: 'AS Admin', icon: 'mdi:account-tie' },
    { id: 'AS_Technical', label: 'AS Technical', icon: 'mdi:account-tie' },
    { id: 'AS_PM_E', label: 'AS PM&E', icon: 'mdi:account-tie' },
    { id: 'DG_Forest', label: 'DG Forest', icon: 'mdi:account-tie' },
    { id: 'GIS_Lab_Manager', label: 'Manager-GisLab', icon: 'mdi:radioactive' },
    { id: 'DS_Wildlife', label: 'DS Wildlife', icon: 'mdi:paw' }
  ];

  const handleChecklistChange = (itemId) => {
    setAdminChecklist(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  useEffect(() => {
    const fetchComplaintData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/complaints/${complainId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          const complaintData = response.data.data;
          setFormData({
            dept_id: complaintData.dept_id?._id || "",
            dept_name: complaintData.dept_id?.name || "",
            complaint_number: complaintData.complaint_number || "",
            district_id: complaintData.complaint_district_id?._id || "",
            complaint_nature_id: complaintData.complaint_nature_id?._id || "",
            complaint_nature_name: complaintData.complaint_nature_id?.name || "",
            complaint_nearby_place: complaintData.near_by_place || "",
            complaint_detail: complaintData.complaint_detail || "",
            complainant_name: complaintData.complainant_name || "",
            complainant_address: complaintData.complainant_address || "",
            complainant_contact_no: complaintData.complainant_contact_no || "",
            complainant_email: complaintData.complainant_email || "",
            complaint_time: complaintData.time_of_call || "",
            complaint_additional_remarks: complaintData.remarks || "",
            complainant_phone_secondry: complaintData.complaint_contact_no_sec || "",
            other_nature: complaintData.other_nature || "",
            received_by: `${complaintData.received_by?.first_name || ''} ${complaintData.received_by?.last_name || ''}`.trim() || "",
            status: complaintData.status || "Open",
            priority_level: complaintData.priority_level || "",
            cnic: complaintData.complainant_cnic || "",
            complaint_source: complaintData.complaint_source || "",
            complainant_city: complaintData.complainant_city_id?.name || "",
            complainant_tehsil: complaintData.complainant_tehsil_id?.name || "",
            complainant_district: complaintData.complainant_district_id?.name || "",
            complaint_city: complaintData.complaint_city_id?.name || "",
            complaint_tehsil: complaintData.complaint_tehsil_id?.name || "",
            complaint_district: complaintData.complaint_district_id?.name || "",
            complaint_address: complaintData.complaint_address || "",
            lat: complaintData.lat || "",
            long: complaintData.long || "",
            assigned_to: `${complaintData.assigned_to?.first_name || ''} ${complaintData.assigned_to?.last_name || ''}`.trim() || "",
            dispatched_time: complaintData.dispatched_time || "",
            referred_by: complaintData.referred_by || "",
            dfo_remarks: complaintData.dfo_remarks || "",
            cancel_reason: complaintData.cancel_reason || "",
            media_array: complaintData.media_array || [],
          });
        }
      } catch (error) {
        toast.error("Failed to fetch complaint data.");
        console.error("Error fetching complaint data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComplaintData();
  }, [API_BASE_URL, complainId, authUserId]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/generic/forestZone`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        setOptions(prev => ({
          ...prev,
          forestZones: Array.isArray(response.data.data) ? response.data.data : [],
        }));
        
      } catch (error) {
        console.error('Error fetching forest zones:', error);
        toast.error("Failed to fetch forest zones.");
      }
    };
    
    fetchOptions();
  }, [API_BASE_URL]);

  useEffect(() => {
    const fetchCirclesAndDivisions = async () => {
      if (formDataForest.forestZone) {
        try {
          const token = localStorage.getItem("token");
          const selectedZone = options.forestZones.find(zone => zone._id === formDataForest.forestZone);
          if (!selectedZone) return;

          const response = await axios.post(
            `${API_BASE_URL}/backend/districts/get-circles-and-divisions-by-zone`,
            { zone: selectedZone.name },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.data.status) {
            setOptions(prev => ({
              ...prev,
              forestCircles: response.data.circles || [],
              forestDivisions: [], // Clear divisions until a circle is selected
              forestNames: [] // ← Clear forest names
            }));
            // Reset circle, division and forest name when zone changes
            setFormDataForest(prev => ({
              ...prev,
              forestCircle: '',
              forestDivision: '',
              forestName: ''
            }));
          } else {
            toast.error("Failed to fetch circles and divisions.");
          }
        } catch (error) {
          console.error('Error fetching circles and divisions:', error);
          toast.error("Failed to fetch circles and divisions.");
        }
      } else {
        // Clear circles, divisions and forest names if no zone is selected
        setOptions(prev => ({
          ...prev,
          forestCircles: [],
          forestDivisions: [],
          forestNames: []
        }));
        setFormDataForest(prev => ({
          ...prev,
          forestCircle: '',
          forestDivision: '',
          forestName: ''
        }));
      }
    };

    fetchCirclesAndDivisions();
  }, [formDataForest.forestZone, options.forestZones, API_BASE_URL]);

  useEffect(() => {
    const updateDivisions = () => {
      if (formDataForest.forestCircle && formDataForest.forestZone) {
        const selectedCircle = options.forestCircles.find(circle => circle._id === formDataForest.forestCircle);
        if (selectedCircle) {
          setOptions(prev => ({
            ...prev,
            forestDivisions: selectedCircle.divisions || [],
            forestNames: [] // ← Clear forest names when circle changes
          }));
          // Reset division and forest name when circle changes
          setFormDataForest(prev => ({
            ...prev,
            forestDivision: '',
            forestName: ''
          }));
        }
      } else {
        setOptions(prev => ({
          ...prev,
          forestDivisions: [],
          forestNames: []
        }));
        setFormDataForest(prev => ({
          ...prev,
          forestDivision: '',
          forestName: ''
        }));
      }
    };

    updateDivisions();
  }, [formDataForest.forestCircle, formDataForest.forestZone, options.forestCircles]);

  // ← NEW EFFECT: Fetch Forest Names when Division changes
  useEffect(() => {
    const fetchForestNames = async () => {
      if (formDataForest.forestDivision) {
        try {
          const token = localStorage.getItem("token");
          const selectedDivision = options.forestDivisions.find(div => div._id === formDataForest.forestDivision);
          if (!selectedDivision) return;

          const response = await axios.post(
            `${API_BASE_URL}/backend/districts/get-all-forests-of-division`,
            { divisionName: selectedDivision.name },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.data.success) {
            setOptions(prev => ({
              ...prev,
              forestNames: response.data.data || []
            }));
            setFormDataForest(prev => ({ ...prev, forestName: '' })); // Reset selection
          } else {
            toast.error("Failed to fetch forest names.");
            setOptions(prev => ({ ...prev, forestNames: [] }));
          }
        } catch (error) {
          console.error('Error fetching forest names:', error);
          toast.error("Failed to fetch forest names.");
          setOptions(prev => ({ ...prev, forestNames: [] }));
        }
      } else {
        setOptions(prev => ({ ...prev, forestNames: [] }));
        setFormDataForest(prev => ({ ...prev, forestName: '' }));
      }
    };

    fetchForestNames();
  }, [formDataForest.forestDivision, options.forestDivisions, API_BASE_URL]);

  const getPriorityClasses = (priority) => {
    switch (priority) {
      case "Low":
        return "bg-info-focus text-info-600";
      case "Medium":
        return "bg-success-focus text-success-600";
      case "High":
        return "bg-warning-focus text-warning-600";
      case "Critical":
        return "bg-danger-focus text-danger-600";
      default:
        return "bg-secondary text-secondary-600";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataForest(prev => ({ ...prev, [name]: value }));
    
    // Reset checklist when changing assigned officer
    if (name === "assignedOfficer") {
      setSelectedOtherUserId('');
      setAdminChecklist({
        SO_Forest: false,
        AS_Admin: false,
        AS_Technical: false,
        AS_PM_E: false,
        DG_Forest: false,
        GIS_Lab_Manager: false
      });
    }
    
    if (name === "complaintAction" && value !== "Close") {
      setSelectedSuggestions([]);
      setFormDataForest(prev => ({ ...prev, closeRemarks: '' }));
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSelectedSuggestions(prev => {
      const newSuggestions = prev.includes(suggestion)
        ? prev.filter(item => item !== suggestion)
        : [...prev, suggestion];
      
      const message = newSuggestions.length > 0
        ? newSuggestions.join(' ')
        : '';
      
      setFormDataForest(prev => ({ ...prev, closeRemarks: message }));
      return newSuggestions;
    });
  };

  const officerHierarchy = [
    { value: 'DFO', label: 'DCF', color: 'primary', icon: 'mdi:account-tie' },
    { value: 'CF', label: 'Conservator of Forests', color: 'success', icon: 'mdi:account-tie-hat' },
    { value: 'CCF', label: 'Chief Conservator of Forests', color: 'warning', icon: 'mdi:account-supervisor' },
    { value: 'ASAdmin', label: 'Administrative Department', color: 'danger', icon: 'mdi:account-cog' },
    { value: 'OTHERS', label: 'Others', color: 'info', icon: 'mdi:account-search' }
  ];

  useEffect(() => {
    if (formDataForest.assignedOfficer !== 'OTHERS' || otherUsers.length > 0) return;

    const fetchOtherUsers = async () => {
      setIsLoadingOtherUsers(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/users/dispatch/other-options`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOtherUsers(response.data?.data || []);
      } catch (error) {
        setOtherUsers([]);
        toast.error(error.response?.data?.message || "Failed to load other users.");
      } finally {
        setIsLoadingOtherUsers(false);
      }
    };

    fetchOtherUsers();
  }, [API_BASE_URL, formDataForest.assignedOfficer, otherUsers.length]);

  const getCCOfficers = (selectedOfficer) => {
    switch(selectedOfficer) {
      case 'DFO':
        return [
          { value: 'CF', label: 'Conservator of Forests', color: 'success', icon: 'mdi:account-tie-hat' },
          { value: 'CCF', label: 'Chief Conservator of Forests', color: 'warning', icon: 'mdi:account-supervisor' },
          { value: 'ASAdmin', label: 'Administrative Department', color: 'danger', icon: 'mdi:account-cog' }
        ];
      case 'CF':
        return [
          { value: 'CCF', label: 'Chief Conservator of Forests', color: 'warning', icon: 'mdi:account-supervisor' },
          { value: 'ASAdmin', label: 'Administrative Department', color: 'danger', icon: 'mdi:account-cog' }
        ];
      case 'CCF':
        return [
          { value: 'ASAdmin', label: 'Administrative Department', color: 'danger', icon: 'mdi:account-cog' }
        ];
      case 'ASAdmin':
        return [];
      default:
        return [];
    }
  };

  const getOfficerColor = (officerValue) => {
    const officer = officerHierarchy.find(o => o.value === officerValue);
    return officer ? officer.color : 'secondary';
  };

  const getOfficerIcon = (officerValue) => {
    const officer = officerHierarchy.find(o => o.value === officerValue);
    return officer ? officer.icon : 'mdi:account';
  };

  const normalizeMediaUrls = (mediaItems = []) => {
    return mediaItems
      .map((item) => getMediaUrl(item))
      .filter(Boolean);
  };

  // Get payload values based on selection
  const getPayloadValues = (selectedOfficer) => {
    const payload = {
      DFO: false,
      CF: false,
      CCF: false,
      ADMINISTRATIVE_DEPARTMENT: false,
      SO_FOREST: adminChecklist.SO_Forest,
      AS_ADMIN: adminChecklist.AS_Admin,
      AS_TECH: adminChecklist.AS_Technical,
      AS_PMAE: adminChecklist.AS_PM_E,
      DF_FOREST: adminChecklist.DG_Forest,
      GIS_LAB_MANAGER: adminChecklist.GIS_Lab_Manager,
      DS_WILDLIFE: adminChecklist.DS_Wildlife
    };

    switch(selectedOfficer) {
      
      case 'CF':
        payload.CF = true;
        payload.CCF = true;
        break;
      case 'CCF':
        payload.CCF = true;
        break;
      case 'ASAdmin':
        payload.ADMINISTRATIVE_DEPARTMENT = true;
        break;
      case 'OTHERS':
        break;
        default:
        payload.DFO = true;
        payload.CF = true;
        payload.CCF = true;
        break;
          
    }
    return payload;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    if (formDataForest.complaintAction === 'Close') {
      if (!formDataForest.closeRemarks) {
        toast.error("Please provide remarks for closing the complaint!");
        setIsSubmitting(false);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token not found. Please login again.");
          setIsSubmitting(false);
          return;
        }

        const closeData = {
          id: complainId,
          status: "Closed",
          user_remarks: formDataForest.closeRemarks,
          user_media_array: closureEvidenceUrls,
        };

        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/change-status`,
          closeData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          toast.success("Complaint closed successfully!");
          navigate("/dispatch/list", { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to close complaint.");
        }
      } catch (postError) {
        toast.error(postError.response?.data?.message || "Failed to close complaint.");
        console.error("Error closing complaint:", postError);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      const requiredFields = [
        'forestZone',
        'forestCircle',
        'forestDivision',
        'forestName', // ← NOW REQUIRED
        'assignedOfficer',
      ];

      const isFormValid = requiredFields.every((field) => formDataForest[field] !== "");
      if (!isFormValid) {
        toast.error("Please fill in all required dispatch details!");
        setIsSubmitting(false);
        return;
      }

      if (formDataForest.assignedOfficer === 'OTHERS' && !selectedOtherUserId) {
        toast.error("Please select a user to assign the complaint.");
        setIsSubmitting(false);
        return;
      }

      // Get exact payload values as specified
      const payloadValues = getPayloadValues(formDataForest.assignedOfficer);
      const existingEvidenceUrls = normalizeMediaUrls(formData.media_array);
      const combinedDispatchEvidenceUrls = [...new Set([...existingEvidenceUrls, ...dispatchEvidenceUrls])];

      const apiData = {
        id: complainId,
        complaint_action: formDataForest.complaintAction,
        complaint_forest_zone_id: formDataForest.forestZone,
        complaint_forest_circle_id: formDataForest.forestCircle,
        complaint_forest_division_id: formDataForest.forestDivision,
        complaint_forest_id: formDataForest.forestName, // ← SEND FOREST ID
        DFO: payloadValues.DFO,
        CF: payloadValues.CF,
        CCF: payloadValues.CCF,
        ADMINISTRATIVE_DEPARTMENT: payloadValues.ADMINISTRATIVE_DEPARTMENT,
        SO_FOREST: payloadValues.SO_FOREST,
        AS_ADMIN: payloadValues.AS_ADMIN,
        AS_TECH: payloadValues.AS_TECH,
        AS_PMAE: payloadValues.AS_PMAE,
        DF_FOREST: payloadValues.DF_FOREST,
        GIS_LAB_MANAGER: payloadValues.GIS_LAB_MANAGER,
        DS_WILDLIFE: payloadValues.DS_WILDLIFE,
        assigned_to: formDataForest.assignedOfficer === 'OTHERS' ? selectedOtherUserId : undefined,
        media_array: combinedDispatchEvidenceUrls,
      };

      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/dispatch`,
          apiData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          try {
            const responseData = response.data.data || {};
            const dfoNumber = responseData.dfo_number;
            const phoneNumbers = new Set();

            if (dfoNumber) phoneNumbers.add(dfoNumber);
            phoneNumbers.add("03379926560");

            if (phoneNumbers.size > 0) {
              const smsMessage = `Respected Sir,
A complaint ${responseData.complaint_number || ''} from ${responseData.complaint_location || ''} is registered by ${responseData.complainant_name || ''} - ${responseData.complainant_phone_no || ''} regarding ${responseData.complaint_nature || ''}. Please review and take necessary action by login into cms.punjabeforest.gop.pk Regards, 1084-Control Room.`;

              await Promise.all(Array.from(phoneNumbers).map(phone => 
                axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
                  params: {
                    sec_key: process.env.REACT_APP_PITB_KEY,
                    sms_text: smsMessage,
                    phone_no: phone,
                    sms_language: 'english'
                  }
                })
              ));
            }
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          toast.success("Complaint dispatched successfully!");
          navigate("/dispatch/list", { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to dispatch complaint.");
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || "Failed to dispatch complaint. Please try again.";
        toast.error(errorMessage);
        console.error("Error dispatching complaint:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const ccOfficers = getCCOfficers(formDataForest.assignedOfficer);
  const selectedOtherUser = otherUsers.find((user) => user._id === selectedOtherUserId);
  const selectedOtherUserHierarchy = [...(selectedOtherUser?.upper_hirarchy || [])]
    .filter((item) => item?.user_id)
    .sort((a, b) => a.level - b.level);
  const displayedSuggestions = showAllSuggestions ? suggestions : suggestions.slice(0, 3);
  const showChecklistInCC = formDataForest.assignedOfficer !== 'ASAdmin';
  const showChecklistInAssigned = formDataForest.assignedOfficer === 'ASAdmin';

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <ToastContainer />
      
      <div className="text-center"></div>
      
      <div className="card-body py-10">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="shadow-4 border radius-8">
              <div className="p-20 border-bottom fs-5">
                <div className="row justify-content-between g-3">
                  <div className="col-sm-6">
                    <h4 className="mb-20">{formData.complaint_number} <span className={`px-3 py-1 rounded-pill fw-semibold text-xl ${getPriorityClasses(formData.priority_level)}`}>
                      {formData.priority_level || 'No Data Found'}
                    </span></h4>
                    <div className="space-y-2">
                      {[
                        { label: 'Complaint Time', icon: 'mdi:clock-outline', value: formData.complaint_time },
                        { label: 'Department', icon: 'mdi:office-building', value: formData.dept_name },
                        {
                          label: 'Source of Complaint',
                          icon: 'mdi:source-branch',
                          value: (
                            <>
                              {formData.complaint_source}
                              {formData.complaint_source === 'Public Form' && formData.media_array?.length > 0 && (
                                <button
                                  className="btn btn-sm btn-success-600 mx-20"
                                  onClick={() => setShowAttachmentsModal(true)}
                                  data-bs-toggle="modal"
                                  data-bs-target="#attachmentsModal"
                                >
                                  Show Evidence
                                </button>
                              )}
                            </>
                          )
                        },
                        {
                          label: 'Nature of Complaint',
                          icon: 'mdi:alert-circle',
                          value: (
                            <>
                              {formData.complaint_nature_name}
                              {formData.complaint_nature_name === 'Other' && formData.other_nature && (
                                <span className="ms-2 text-muted fst-italic">({formData.other_nature})</span>
                              )}
                            </>
                          )
                        },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex justify-content-between">
                          <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                            <Icon icon={icon} /> {label}
                          </span>
                          <span className="col-1">:</span>
                          <span className="col-7 text-decoration-underline">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-sm-6 space-y-2">
                    {[
                      { label: 'Nearby Place', icon: 'mdi:map-marker', value: formData.complaint_nearby_place },
                      { label: 'Complaint Tehsil', icon: 'mdi:map', value: formData.complaint_tehsil },
                      { label: 'Complaint District', icon: 'mdi:map-outline', value: formData.complaint_district },
                      { label: 'Complaint Address', icon: 'mdi:home-map-marker', value: formData.complaint_address },
                      { label: 'Received By', icon: 'mdi:account', value: formData.received_by },
                    ].map(({ label, icon, value }, index) => (
                      <div key={index} className="d-flex justify-content-between">
                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                          <Icon icon={icon} /> {label}
                        </span>
                        <span className="col-1">:</span>
                        <span className="col-7 text-decoration-underline">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-12 mt-3">
                    <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                      <Icon icon="mdi:clipboard-text" />Complaint Details
                    </h6>
                    <p>{formData.complaint_detail || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
              
              <hr/>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-12 mt-3">
                    <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                      <Icon icon="mdi:text" />Additional Remarks
                    </h6>
                    <p>{formData.complaint_additional_remarks || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
              
              <hr/>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Information:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Name', icon: 'mdi:account', value: formData.complainant_name },
                        { label: 'Phone Number', icon: 'mdi:phone', value: formData.complainant_contact_no },
                        { label: 'Email', icon: 'mdi:email', value: formData.complainant_email },
                          ...(formData.complainant_phone_secondry
                            ? [{ label: 'Phone Secondary', icon: 'mdi:phone', value: formData.complainant_phone_secondry }]
                            : []),
                        { label: 'CNIC', icon: 'mdi:id-card', value: formData.cnic },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Address:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Address', icon: 'mdi:home', value: formData.complainant_address },
                        { label: 'Tehsil', icon: 'mdi:map', value: formData.complainant_tehsil },
                        { label: 'District', icon: 'mdi:map', value: formData.complainant_district },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-24">
                  <div className="scroll-sm">
                    <form onSubmit={handleSubmit}>
                      <div>
                        <div className="mb-4">
                          <div className="text-lg font-semibold">Analyze Complaint</div>
                          <hr className="my-3" />
                          
                          <div className="row gy-3">
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                              <label className="form-label d-flex align-items-center gap-2" htmlFor="complaintAction">
                                <Icon icon="mdi:clipboard-check" className="text-lg" />
                                Complaint Action
                              </label>
                              <select
                                id="complaintAction"
                                name="complaintAction"
                                value={formDataForest.complaintAction}
                                onChange={handleChange}
                                className="form-select"
                                required
                                disabled={isSubmitting}
                              >
                                <option value="Proceed">Proceed Complaint</option>
                                <option value="Close">Close Complaint</option>
                              </select>
                            </div>

                            {formDataForest.complaintAction === 'Close' && (
                              <>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2" htmlFor="closeRemarks">
                                    <Icon icon="mdi:comment-text" className="text-lg" />
                                    Remarks <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    id="closeRemarks"
                                    name="closeRemarks"
                                    value={formDataForest.closeRemarks}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter remarks for closing the complaint"
                                    required
                                    disabled={isSubmitting}
                                  />
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2">
                                    <Icon icon="mdi:lightbulb" className="text-lg" />
                                    Suggested Reasons
                                  </label>
                                  <div className="d-flex flex-wrap gap-2 align-items-center">
                                    {displayedSuggestions.map((suggestion, index) => (
                                      <button
                                        key={index}
                                        type="button"
                                        className={`btn btn-sm ${
                                          selectedSuggestions.includes(suggestion)
                                            ? 'btn-success'
                                            : 'btn-outline-success'
                                        }`}
                                        onClick={() => handleSuggestionClick(suggestion)}
                                        disabled={isSubmitting}
                                      >
                                        {suggestion}
                                      </button>
                                    ))}
                                    {suggestions.length > 3 && (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-link text-success-900"
                                        onClick={() => setShowAllSuggestions(!showAllSuggestions)}
                                        disabled={isSubmitting}
                                      >
                                        {showAllSuggestions ? 'Show Less..' : 'See More..'}
                                      </button>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2">
                                    <Icon icon="mdi:file-upload" className="text-lg" />
                                    Closure Evidence (if any)
                                  </label>
                                  <ComplaintUploadWithImagePreviewList
                                    onFileUploadSuccess={(url) => {
                                      setClosureEvidenceUrls(prev => [...prev, url]);
                                    }}
                                  />
                                  <label className="text-sm mt-1 mb-0">
                                    Upload up to 5 supported files in PDF, Word, image, or video format (Max 5 MB each)
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {formDataForest.complaintAction === 'Proceed' && (
                  <div className="mt-24">
                    <div className="scroll-sm">
                      <form onSubmit={handleSubmit}>
                        <div>
                          <div className="mb-4">
                            <div className="text-lg font-semibold">Dispatch Information</div>
                            <hr className="my-3" />
                            
                            <div className="row gy-3">
                              <div className="col-12 mb-4">
                                <div className="row">
                                  <div className="col-lg-4 col-md-12 col-sm-12 mb-4">
                                    <label className="form-label d-flex align-items-center gap-2" htmlFor="assignedOfficer">
                                      <Icon icon="mdi:account-group" className="text-lg" />
                                      Assign To
                                    </label>
                                    <select
                                      id="assignedOfficer"
                                      name="assignedOfficer"
                                      value={formDataForest.assignedOfficer}
                                      onChange={handleChange}
                                      className="form-select"
                                      required
                                      disabled={isSubmitting}
                                    >
                                      <option value="">Select Officer</option>
                                      {officerHierarchy.map(officer => (
                                        <option key={officer.value} value={officer.value}>
                                          {officer.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  {formDataForest.assignedOfficer && (
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                      {/* Officer cards remain unchanged */}
                                      <style>{`
                                        @keyframes slideInLeft {
                                          from { opacity: 0; transform: translateX(-30px); }
                                          to { opacity: 1; transform: translateX(0); }
                                        }
                                        @keyframes slideInRight {
                                          from { opacity: 0; transform: translateX(30px); }
                                          to { opacity: 1; transform: translateX(0); }
                                        }
                                        @keyframes fadeInUp {
                                          from { opacity: 0; transform: translateY(10px); }
                                          to { opacity: 1; transform: translateY(0); }
                                        }
                                        @keyframes scaleIn {
                                          from { opacity: 0; transform: scale(0.9); }
                                          to { opacity: 1; transform: scale(1); }
                                        }
                                        @keyframes pulse {
                                          0%, 100% { transform: scale(1); }
                                          50% { transform: scale(1.05); }
                                        }
                                        .animate-slide-left { animation: slideInLeft 0.5s ease-out forwards; }
                                        .animate-slide-right { animation: slideInRight 0.5s ease-out forwards; }
                                        .animate-fade-up { animation: fadeInUp 0.4s ease-out forwards; }
                                        .animate-scale { animation: scaleIn 0.3s ease-out forwards; }
                                        .officer-card { 
                                          transition: all 0.3s ease; 
                                          position: relative; 
                                          overflow: hidden; 
                                          display: flex; 
                                          flex-direction: column; 
                                          justify-content: center; 
                                          min-height: 200px; 
                                        }
                                        .officer-card::before {
                                          content: ''; 
                                          position: absolute; 
                                          top: 0; 
                                          left: -100%; 
                                          width: 100%; 
                                          height: 100%;
                                          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                                          transition: left 0.5s ease;
                                        }
                                        .officer-card:hover::before { left: 100%; }
                                        .officer-card:hover { transform: translateY(-5px); box-shadow: 0 8px 24px rgba(0,0,0,0.15) !important; }
                                        .officer-avatar { transition: all 0.3s ease; }
                                        .officer-card:hover .officer-avatar { animation: pulse 0.6s ease-in-out; }
                                        .cc-item { transition: all 0.2s ease; }
                                        .cc-item:hover { transform: translateX(5px); background-color: rgba(0,0,0,0.05) !important; }
                                        .checklist-item {
                                          transition: all 0.2s ease; 
                                          border-radius: 8px; 
                                          padding: 8px 12px; 
                                          cursor: pointer;
                                          flex: 1 1 30%; 
                                          max-width: 33.33%;
                                        }
                                        .checklist-item:hover { background-color: rgba(0,123,255,0.05); }
                                        .checklist-item.checked { background-color: rgba(40,167,69,0.1); border-left: 4px solid #28a745; }
                                        .card-header-gradient-primary { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
                                        .card-header-gradient-success { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }
                                        .checklist-container { 
                                          display: flex; 
                                          flex-wrap: wrap; 
                                          gap: 8px; 
                                          justify-content: flex-start; 
                                        }
                                        .checklist-row { 
                                          display: flex; 
                                          flex-wrap: wrap; 
                                          gap: 8px; 
                                          width: 100%; 
                                        }
                                      `}</style>
                                      <div className="row g-3">
                                        <div className="col-lg-6 col-md-6 col-sm-12 animate-slide-left">
                                          <div className="card border-0 shadow-sm h-100 officer-card">
                                            <div className="card-header card-header-gradient-primary text-white">
                                              <h6 className="mb-0 d-flex text-white align-items-center gap-2">
                                                <Icon icon="mdi:account-check" />Assigned To:
                                              </h6>
                                            </div>
                                            <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                                              <div className={`avatar avatar-xl bg-${getOfficerColor(formDataForest.assignedOfficer)}-light rounded-circle d-flex align-items-center justify-content-center mb-3 officer-avatar`} style={{width: '80px', height: '80px'}}>
                                                <Icon icon={getOfficerIcon(formDataForest.assignedOfficer)} className={`text-${getOfficerColor(formDataForest.assignedOfficer)}`} style={{fontSize: '2.5rem'}} />
                                              </div>
                                              <h6 className="card-title text-dark mb-1 fw-bold">
                                                {officerHierarchy.find(o => o.value === formDataForest.assignedOfficer)?.label}
                                              </h6>
                                              <p className="text-muted mb-0 small">Primary Responsibility</p>

                                              {formDataForest.assignedOfficer === 'OTHERS' && (
                                                <div className="mt-3 pt-3 border-top w-100">
                                                  <h6 className="text-info mb-2 small text-center">Select a user:</h6>
                                                  {isLoadingOtherUsers ? (
                                                    <div className="text-center text-muted small py-2">Loading users...</div>
                                                  ) : otherUsers.length === 0 ? (
                                                    <div className="text-center text-muted small py-2">No users available.</div>
                                                  ) : (
                                                    <div className="d-flex flex-column gap-2" style={{ maxHeight: '240px', overflowY: 'auto' }}>
                                                      {otherUsers.map((user) => {
                                                        const checkboxId = `other-user-${user._id}`;
                                                        const isSelected = selectedOtherUserId === user._id;
                                                        const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
                                                        return (
                                                          <label
                                                            key={user._id}
                                                            htmlFor={checkboxId}
                                                            className={`d-flex align-items-center gap-2 border rounded p-2 mb-0 ${isSelected ? 'border-info bg-info-focus' : ''}`}
                                                            style={{ cursor: 'pointer' }}
                                                          >
                                                            <input
                                                              id={checkboxId}
                                                              type="checkbox"
                                                              className="form-check-input m-0"
                                                              checked={isSelected}
                                                              onChange={() => setSelectedOtherUserId(isSelected ? '' : user._id)}
                                                            />
                                                            <span className="small text-start">
                                                              <strong>{user.designation || 'No designation'}</strong>
                                                              {fullName ? <span className="text-muted"> — {fullName}</span> : null}
                                                            </span>
                                                          </label>
                                                        );
                                                      })}
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                              
                                              {showChecklistInAssigned && (
                                                <div className="mt-3 pt-3 border-top w-100">
                                                  <h6 className="text-danger mb-2 small text-center">Select Recipients:</h6>
                                                  <div className="checklist-container">
                                                    <div className="checklist-row">
                                                      {checklistItems.slice(0, 3).map((item) => (
                                                        <div
                                                          key={item.id}
                                                          className={`checklist-item d-flex align-items-center gap-2 p-2 ${adminChecklist[item.id] ? 'checked' : ''}`}
                                                          onClick={(e) => { if (e.target.type !== 'checkbox') handleChecklistChange(item.id); }}
                                                        >
                                                          <input
                                                            type="checkbox"
                                                            id={item.id}
                                                            checked={adminChecklist[item.id]}
                                                            onChange={() => handleChecklistChange(item.id)}
                                                            className="form-check-input me-2"
                                                          />
                                                          <Icon icon={item.icon} className="text-muted" style={{fontSize: '1rem'}} />
                                                          <span className="small fw-medium">{item.label}</span>
                                                        </div>
                                                      ))}
                                                    </div>
                                                    <div className="checklist-row">
                                                      {checklistItems.slice(3).map((item) => (
                                                        <div
                                                          key={item.id}
                                                          className={`checklist-item d-flex align-items-center gap-2 p-2 ${adminChecklist[item.id] ? 'checked' : ''}`}
                                                          onClick={(e) => { if (e.target.type !== 'checkbox') handleChecklistChange(item.id); }}
                                                        >
                                                          <input
                                                            type="checkbox"
                                                            id={item.id}
                                                            checked={adminChecklist[item.id]}
                                                            onChange={() => handleChecklistChange(item.id)}
                                                            className="form-check-input me-2"
                                                          />
                                                          <Icon icon={item.icon} className="text-muted" style={{fontSize: '1rem'}} />
                                                          <span className="small fw-medium">{item.label}</span>
                                                        </div>
                                                      ))}
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12 animate-slide-right">
                                          <div className="card border-0 shadow-sm h-100 officer-card">
                                            <div className="card-header card-header-gradient-success text-white">
                                              <h6 className="mb-0 d-flex text-white align-items-center gap-2">
                                                <Icon icon="mdi:account-multiple" />CC:
                                              </h6>
                                            </div>
                                            <div className="card-body p-3 d-flex flex-column align-items-center justify-content-center">
                                              {formDataForest.assignedOfficer === 'OTHERS' ? (
                                                selectedOtherUserHierarchy.length > 0 ? (
                                                  <div className="space-y-2 w-100">
                                                    {selectedOtherUserHierarchy.map((hierarchyItem, index) => {
                                                      const hierarchyUser = hierarchyItem.user_id;
                                                      const fullName = `${hierarchyUser.first_name || ''} ${hierarchyUser.last_name || ''}`.trim();
                                                      return (
                                                        <div
                                                          key={hierarchyUser._id || `${hierarchyItem.level}-${index}`}
                                                          className="d-flex align-items-center gap-2 p-2 bg-light rounded cc-item animate-fade-up"
                                                          style={{animationDelay: `${index * 0.1}s`}}
                                                        >
                                                          <div className="avatar avatar-sm bg-success-light rounded-circle d-flex align-items-center justify-content-center" style={{minWidth: '40px', height: '40px'}}>
                                                            <Icon icon="mdi:account-arrow-up" className="text-success" style={{fontSize: '1.25rem'}} />
                                                          </div>
                                                          <span className="text-dark small fw-medium">
                                                            {hierarchyUser.designation || hierarchyItem.designation || 'No designation'}
                                                            {fullName ? <span className="text-muted"> — {fullName}</span> : null}
                                                          </span>
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                ) : (
                                                  <div className="text-center py-3 animate-scale">
                                                    <Icon icon="mdi:information-outline" className="text-muted mb-2" style={{fontSize: '2rem'}} />
                                                    <p className="text-muted mb-0 small">
                                                      {selectedOtherUserId ? 'No upper hierarchy recipients' : 'Select a user to view CC recipients'}
                                                    </p>
                                                  </div>
                                                )
                                              ) : formDataForest.assignedOfficer === 'ASAdmin' ? (
                                                <div className="text-center py-3 animate-scale">
                                                  <Icon icon="mdi:information-outline" className="text-muted mb-2" style={{fontSize: '2rem'}} />
                                                  <p className="text-muted mb-0 small">No CC Recipients</p>
                                                </div>
                                              ) : (
                                                <>
                                                  <div className="space-y-2 mb-3 w-100">
                                                    {ccOfficers.slice(0, -1).map((officer, index) => (
                                                      <div 
                                                        key={officer.value} 
                                                        className="d-flex align-items-center gap-2 p-2 bg-light rounded cc-item animate-fade-up"
                                                        style={{animationDelay: `${index * 0.1}s`}}
                                                      >
                                                        <div className={`avatar avatar-sm bg-${officer.color}-light rounded-circle d-flex align-items-center justify-content-center`} style={{minWidth: '40px', height: '40px'}}>
                                                          <Icon icon={officer.icon} className={`text-${officer.color}`} style={{fontSize: '1.25rem'}} />
                                                        </div>
                                                        <span className="text-dark small fw-medium">{officer.label}</span>
                                                      </div>
                                                    ))}
                                                  </div>
                                                  
                                                  {showChecklistInCC && ccOfficers[ccOfficers.length - 1]?.value === 'ASAdmin' && (
                                                    <div className="pt-3 border-top w-100">
                                                      <h6 className="text-danger mb-2 small text-center">Administrative Department:</h6>
                                                      <div className="checklist-container">
                                                        <div className="checklist-row">
                                                          {checklistItems.slice(0, 3).map((item) => (
                                                            <div
                                                              key={item.id}
                                                              className={`checklist-item d-flex align-items-center gap-2 p-2 ${adminChecklist[item.id] ? 'checked' : ''}`}
                                                              onClick={(e) => { if (e.target.type !== 'checkbox') handleChecklistChange(item.id); }}
                                                            >
                                                              <input
                                                                type="checkbox"
                                                                id={item.id}
                                                                checked={adminChecklist[item.id]}
                                                                onChange={() => handleChecklistChange(item.id)}
                                                                className="form-check-input me-2"
                                                              />
                                                              <Icon icon={item.icon} className="text-muted" style={{fontSize: '1rem'}} />
                                                              <span className="small fw-medium">{item.label}</span>
                                                            </div>
                                                          ))}
                                                        </div>
                                                        <div className="checklist-row">
                                                          {checklistItems.slice(3).map((item) => (
                                                            <div
                                                              key={item.id}
                                                              className={`checklist-item d-flex align-items-center gap-2 p-2 ${adminChecklist[item.id] ? 'checked' : ''}`}
                                                              onClick={(e) => { if (e.target.type !== 'checkbox') handleChecklistChange(item.id); }}
                                                            >
                                                              <input
                                                                type="checkbox"
                                                                id={item.id}
                                                                checked={adminChecklist[item.id]}
                                                                onChange={() => handleChecklistChange(item.id)}
                                                                className="form-check-input me-2"
                                                              />
                                                              <Icon icon={item.icon} className="text-muted" style={{fontSize: '1rem'}} />
                                                              <span className="small fw-medium">{item.label}</span>
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                                <label className="form-label d-flex align-items-center gap-2" htmlFor="forestZone">
                                  <Icon icon="mdi:tree" className="text-lg" />
                                  Forest Zone
                                </label>
                                <select
                                  id="forestZone"
                                  name="forestZone"
                                  value={formDataForest.forestZone}
                                  onChange={handleChange}
                                  className="form-select"
                                  required
                                  disabled={isSubmitting}
                                >
                                  <option value="">Select Forest Zone</option>
                                  {options.forestZones.map(option => (
                                    <option key={option._id} value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                                <label className="form-label d-flex align-items-center gap-2" htmlFor="forestCircle">
                                  <Icon icon="mdi:tree" className="text-lg" />
                                  Forest Circle
                                </label>
                                <select
                                  id="forestCircle"
                                  name="forestCircle"
                                  value={formDataForest.forestCircle}
                                  onChange={handleChange}
                                  className="form-select"
                                  required
                                  disabled={isSubmitting || !formDataForest.forestZone}
                                >
                                  <option value="">Select Forest Circle</option>
                                  {options.forestCircles.map(option => (
                                    <option key={option._id} value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                                <label className="form-label d-flex align-items-center gap-2" htmlFor="forestDivision">
                                  <Icon icon="mdi:tree" className="text-lg" />
                                  Forest Division
                                </label>
                                <select
                                  id="forestDivision"
                                  name="forestDivision"
                                  value={formDataForest.forestDivision}
                                  onChange={handleChange}
                                  className="form-select"
                                  required
                                  disabled={isSubmitting || !formDataForest.forestCircle}
                                >
                                  <option value="">Select Forest Division</option>
                                  {options.forestDivisions.map(option => (
                                    <option key={option._id} value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              {/* ← NEW FOREST NAME DROPDOWN */}
                              <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                                <label className="form-label d-flex align-items-center gap-2" htmlFor="forestName">
                                  <Icon icon="mdi:pine-tree" className="text-lg" />
                                  Forest Name
                                </label>
                                <select
                                  id="forestName"
                                  name="forestName"
                                  value={formDataForest.forestName}
                                  onChange={handleChange}
                                  className="form-select"
                                  required
                                  disabled={isSubmitting || !formDataForest.forestDivision || options.forestNames.length === 0}
                                >
                                  <option value="">
                                    {options.forestNames.length === 0 ? 'No forests available' : 'Select Forest Name'}
                                  </option>
                                  {options.forestNames.map(forest => (
                                    <option key={forest._id} value={forest._id}>
                                      {forest.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              {formData.complaint_source !== 'Public Form' && (
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <label className="form-label d-flex text-md align-items-center gap-2">
                                    <Icon icon="mdi:file-upload" className="text-lg" />
                                    Evidence if any
                                  </label>
                                  <ComplaintUploadWithImagePreviewList
                                    onFileUploadSuccess={(url) => {
                                      setDispatchEvidenceUrls(prev => [...prev, url]);
                                    }}
                                  />
                                  <label className="text-sm mt-1 mb-0">Upload up to 5 supported files of Pdf, word or Jpg format (Max 5 MB)</label>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-2 col-md-4 col-sm-12"
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {formDataForest.complaintAction === 'Close' ? 'Closing...' : 'Dispatching...'}
                      </>
                    ) : (
                      formDataForest.complaintAction === 'Close' ? 'Close Complaint' : 'Dispatch Complaint'
                    )}
                  </button>
                </div>
              </div>

              <div className="modal fade" id="attachmentsModal" tabIndex="-1" aria-labelledby="attachmentsModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="attachmentsModalLabel">
                        <Icon icon="mdi:paperclip" className="me-2" /> Complaint Evidence
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowAttachmentsModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      {formData.media_array?.length > 0 ? (
                        <ul className="list-unstyled">
                          {formData.media_array.map((attachment, index) => (
                            <li key={index} className="mb-2">
                              <a
                                href={getMediaUrl(attachment)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-success-900 text-decoration-underline font-bold"
                              >
                                ({formData.complaint_number})-Attachment-{index + 1}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted">No attachments available.</p>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={() => setShowAttachmentsModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplainFormPageDispatchUpdate;
